import {Component, ReactNode} from 'react';
import Icon, {IconSize, addIcon} from '@/components/Icon';
import {getDocFillSvgByType, checkIsDocPageByType} from '@/utils/docType';
import Tooltip, {EllipsisTooltip} from '@/components/Tooltip';
import Anchor, {OpenType} from '@/components/Anchor';
import styles from './index.module.scss';
import classNames from 'classnames';

interface IDocLink {
    className?: string;
    svg?: any;
    size?: IconSize;
    url: string;
    docName?: string;
    onClick?: any;
    openWay?: OpenType;
    notShowIcon?: boolean; // 默认false为展示icon
    isInline?: boolean;
    omitColor?: string;
}
const DocLink = (props: IDocLink) => {
    const {className, isInline, omitColor, svg, size, url, docName, onClick, notShowIcon} = props;
    const openWay = props.openWay ?? OpenType.comAndClickOpenNewTab;
    const innerStyle2: React.CSSProperties = {
        display: 'inline-block',
        verticalAlign: 'bottom',
        color: omitColor,
    };
    return (
        <div className={classNames(styles.docLinkBox, className)}>
            {
                !notShowIcon &&
                <Icon
                    className={styles.iconColor}
                    svg={svg}
                    size={size}
                    noSpace
                />
            }
            <EllipsisTooltip
                className={styles.docLinkTooltip}
                content={docName}
                innerStyle={isInline ? innerStyle2 : {}}
                placement={'top'}
            >
                <Anchor
                    className={styles.AnchorColor}
                    url={url}
                    openType={openWay}
                    onClick={onClick}
                >
                    {docName}
                </Anchor>
            </EllipsisTooltip>

        </div>
    );
};
export default DocLink;
